// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"d7364ee35c0a19d523e5","293":"2ad22afe86c9fc2f85d7","454":"1b162ee30f14729fd7a0"}[chunkId] + ".js";
};